import { Injectable } from '@angular/core';

import { UserService } from '@frontend/sports/user/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { delay, map } from 'rxjs';

import SettingsActions from '../../settings/actions';
import { BetslipPlaceBetActions } from '../actions';

@Injectable()
export default class PlaceButtonEffects {
    constructor(
        private actions$: Actions,
        private userService: UserService,
    ) {}

    handlePlaceButtonValidationEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SettingsActions.setOddAcceptance),
            map((action) => BetslipPlaceBetActions.validatePlaceButton({ isValid: true })),
        );
    });

    handleAuthenticationStateChanges$ = createEffect(() => {
        return this.userService.onAuthenticationChange$.pipe(
            //Add delay to ensure the sync user state is updated.
            delay(5),
            map(() => BetslipPlaceBetActions.setAuthentication({ isAuthenticated: this.userService.isAuthenticated })),
        );
    });
}
